"use strict";
import {on, closest, trigger, hasClass, addClass, removeClass, findIn} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

export function init () {
    onFind('.js-filter-dropdown__toggle', function (toggleButton) {
        on('click', function () {
            let $dropdown = closest('.js-filter-dropdown', toggleButton);

            if (hasClass('is-open', $dropdown)) {
                closeDropdown($dropdown);
            } else {
                addClass('is-open', $dropdown);
                trigger('open.filter-dropdown', $dropdown);

                window.addEventListener("click", function _listener(evt) {
                    if (!$dropdown.contains(evt.target)) {
                        closeDropdown($dropdown);

                        window.removeEventListener("click", _listener, true);
                    }
                }, true);

                if (matchMedia('(min-width: 768px)').matches) {
                    let menu = findIn('.js-filter-dropdown__menu', $dropdown);
                    if(menu.getBoundingClientRect().right > window.outerWidth) {
                        addClass('filter-dropdown__menu--right', menu);
                    } else if (menu.getBoundingClientRect().left < 0) {
                        addClass('filter-dropdown__menu--left', menu);
                    }

                    window.addEventListener("keydown", function _keyListener(evt) {
                        if (evt.key === "Escape" || evt.key === "Esc") {
                            closeDropdown($dropdown);

                            window.removeEventListener("keydown", _keyListener, true);
                        }
                    }, true);
                }
            }
        }, toggleButton);

        let $dropdown = closest('.js-filter-dropdown', toggleButton),
            hasChanged = false;

        on('change', function (evt) {
            if (hasClass('is-open', $dropdown)) {
                evt.preventDefault();
                evt.stopImmediatePropagation();
            }

            hasChanged = true;
        }, $dropdown);

        $dropdown.addEventListener('close.filter-dropdown', function(){
            if (hasChanged) {
                trigger('dropdown.change', $dropdown);
                hasChanged = false;
            }
        }, false);
    });

    /* dropdown toggle new */

    onFind('.js-filter-dropdown__toggle--new', function (toggleButton) {
        on('click', function () {
            let $dropdown = closest('.js-filter-dropdown', toggleButton);

            if (hasClass('is-open', $dropdown)) {
                closeDropdown($dropdown);
            } else {
                addClass('is-open', $dropdown);
                trigger('open.filter-dropdown', $dropdown);

                window.addEventListener("click", function _listener(evt) {
                    if (!$dropdown.contains(evt.target)) {
                        closeDropdown($dropdown);

                        window.removeEventListener("click", _listener, true);
                    }
                }, true);

                if (matchMedia('(min-width: 768px)').matches) {
                    let menu = findIn('.js-filter-dropdown__menu', $dropdown);

                    if(menu.getBoundingClientRect().right > window.innerWidth) {
                        addClass('filter-dropdown__menu--right', menu);
                    } else if (menu.getBoundingClientRect().left < 0) {
                        addClass('filter-dropdown__menu--left', menu);
                    }

                    window.addEventListener("keydown", function _keyListener(evt) {
                        if (evt.key === "Escape" || evt.key === "Esc") {
                            closeDropdown($dropdown);

                            window.removeEventListener("keydown", _keyListener, true);
                        }
                    }, true);
                }
            }
        }, toggleButton);

        let $dropdown = closest('.js-filter-dropdown', toggleButton),
            hasChanged = false;

        on('change', function (evt) {
            if (hasClass('is-open', $dropdown)) {
                evt.preventDefault();
                evt.stopImmediatePropagation();
            }
            hasChanged = true;
        }, $dropdown);

        $dropdown.addEventListener('close.filter-dropdown', function(){
            if (hasChanged) {
                trigger('dropdown.change', $dropdown);
                hasChanged = false;
            }
        }, false);
    });
}

function closeDropdown($dropdown) {
    removeClass('is-open', $dropdown);
    removeClass('dropdown-menu-right', findIn('.js-filter-dropdown__menu', $dropdown));
    removeClass('dropdown-menu-left', findIn('.js-filter-dropdown__menu', $dropdown));

    trigger('close.filter-dropdown', $dropdown)
}